import Vue from "vue";

const charts = {
	props: {
		showFooter: { default: true },
		chartHeight: { default: 400 },
		slug: { default: '' },
		period: { default: '' },
		interpreted: { default: 1 }
	}
}

Vue.component("chart-tree-map", {
	mixins: [charts],
	props: ['loading', 'chartData', 'chartName', 'chartDataLabel', 'chartExporting'],
	data() {
		return {
			hasData: true,
			footer: ""
		};
	},
	computed: {
		chartOptions: function () {
			let self = this;
			return {
				styledMode: true,
				chart: { backgroundColor: "", events: {} },
				title: { text: null, align: "left", style: { fontWeight: "bold" } },
				exporting: self.chartExporting,
				borderWidth: 0,
				tooltip: {
					formatter: function () {
						if (this.point.name === 'Others') {
							return `${this.point.name}</b>`;
						}
						else if (this.point.description) {
							return `${this.point.name}: <b>${this.point.value}</b><br/>${this.point.description}`;
						}
						else {
							return `${this.point.name}: <b>${this.point.value}</b>`;
						}
					}
				},
				series: [
					{
						name: self.chartName,
						colorByPoint: true,
						colors: ["#0092cd", "#24c280", "#e1dd5f", "#d9643c"],
						type: "treemap",
						layoutAlgorithm: "squarified",
						data: self.chartData,
						dataLabels: self.chartDataLabel,

					}
				],
			};
		},
	},
	mounted() {
		this.$emit("mounted");
	},
	template: `
		<div>
		    <wto-chart :loading="loading"
		                   :has-data="hasData"
		                   :chart-options="chartOptions"
		                   :footer="footer"></wto-chart>
		</div>
	`
});